import React from 'react';
import { connect } from 'react-redux';

import { Form } from 'react-bootstrap-5';
import { setFilterAttribute } from 'bundles/connect/components/store/actions/criteria';
import CriteriaDecorator from '../../../helpers/criteria_decorator';
import type { Criteria } from 'bundles/connect/types';

type DateRangeInputProps = {
  criteria: Criteria;
  disabled?: boolean;
  maxAttribute: string;
  minAttribute: string;
  percent?: boolean;
  placeholder: string;
  setFilterAttribute: (attribute: string, value: string | null, options?: any) => { type: string } | undefined;
}

function DateRangeInput({
  criteria,
  disabled = false,
  maxAttribute,
  minAttribute,
  placeholder,
  setFilterAttribute
}: DateRangeInputProps) {
  const decoratedCriteria = new CriteriaDecorator(criteria);
  const minValue = decoratedCriteria[minAttribute] ? decoratedCriteria[minAttribute]() : criteria[minAttribute];
  const maxValue = decoratedCriteria[maxAttribute] ? decoratedCriteria[maxAttribute]() : criteria[maxAttribute];

  return (
    <div className="d-flex align-items-center">
      <Form.Control
        className={minValue ? 'active' : ''}
        disabled={disabled}
        placeholder={`Min ${placeholder}`}
        type="date"
        value={minValue || ''}
        onChange={e => setFilterAttribute(minAttribute, e.target.value)}
      />
      <div className="px-1">-</div>
      <Form.Control
        className={maxValue ? 'active' : ''}
        disabled={disabled}
        placeholder={`Max ${placeholder}`}
        type="date"
        value={maxValue || ''}
        onChange={e => setFilterAttribute(maxAttribute, e.target.value)}
      />
    </div>
  );
}

const mapStateToProps = ({ criteria }) => ({ criteria });

export default connect(mapStateToProps, { setFilterAttribute })(DateRangeInput);
